var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(-4074 -1535)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 22,
    height: 22,
    transform: "translate(4074 1535)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M4085.66,1555.071h-6.268a5.27,5.27,0,0,1-2.144-.247,2.25,2.25,0,0,1-1.072-1.072,5.269,5.269,0,0,1-.247-2.144v-6.268a5.269,5.269,0,0,1,.247-2.144,2.25,2.25,0,0,1,1.072-1.072,5.27,5.27,0,0,1,2.144-.247h1.485v-1.485a5.269,5.269,0,0,1,.247-2.144,2.25,2.25,0,0,1,1.072-1.072,5.27,5.27,0,0,1,2.144-.247h6.268a5.27,5.27,0,0,1,2.144.247,2.25,2.25,0,0,1,1.072,1.072,5.269,5.269,0,0,1,.247,2.144v6.268a5.269,5.269,0,0,1-.247,2.144,2.25,2.25,0,0,1-1.072,1.072,5.27,5.27,0,0,1-2.144.247h-1.485v1.485a5.269,5.269,0,0,1-.247,2.144,2.25,2.25,0,0,1-1.072,1.072A5.27,5.27,0,0,1,4085.66,1555.071Zm-6.268-11.545a5.557,5.557,0,0,0-1.4.082l-.33.33a5.557,5.557,0,0,0-.082,1.4v6.268a5.557,5.557,0,0,0,.082,1.4.648.648,0,0,0,.33.33,5.557,5.557,0,0,0,1.4.082h6.268a5.557,5.557,0,0,0,1.4-.082.648.648,0,0,0,.33-.33,5.185,5.185,0,0,0,.082-1.4v-6.268a5.557,5.557,0,0,0-.082-1.4.648.648,0,0,0-.33-.33,5.557,5.557,0,0,0-1.4-.082Zm9.731,4.948h1.485a5.557,5.557,0,0,0,1.4-.082.648.648,0,0,0,.33-.33,5.185,5.185,0,0,0,.082-1.4v-6.268a5.557,5.557,0,0,0-.082-1.4.648.648,0,0,0-.33-.33,5.557,5.557,0,0,0-1.4-.082h-6.268a5.557,5.557,0,0,0-1.4.082l-.33.33a5.557,5.557,0,0,0-.082,1.4v1.485h3.134a5.27,5.27,0,0,1,2.144.247,2.25,2.25,0,0,1,1.072,1.072,5.269,5.269,0,0,1,.247,2.144Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon-copy.7b865682abe9e9c3cdfbb9fb0f5bdf98.svg";
export { ForwardRef as ReactComponent };